const initialState = {
    data: null,
};
export const HoldValReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'HOLDVAL':
            return {
                ...state,
                data: action.payload,
            };
        default:
            return state;
    }
}

export default HoldValReducer;